
export const VALIDATION_MESSAGE = {
  REQUIRED: '必須入力項目です',
  DATE_IN_THE_PAST: '入力が過去日です',
  ENDS_WITHIN_30_DAYS: '30日以内に公開が終了します'
} as const;
